import "./main.css";

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-darkest.css
var $e5b9ee4a968dfaea64b1b8cf98dc184$exports = {};
$e5b9ee4a968dfaea64b1b8cf98dc184$exports = {
  "spectrum--darkest": "_spectrum--darkest_acf7f"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-global.css
var $feb906e4032856f299caea9c$exports = {};
$feb906e4032856f299caea9c$exports = {
  "spectrum": "_spectrum_5be2e",
  "spectrum--medium": "_spectrum--medium_5be2e",
  "spectrum--large": "_spectrum--large_5be2e",
  "spectrum--darkest": "_spectrum--darkest_5be2e",
  "spectrum--dark": "_spectrum--dark_5be2e",
  "spectrum--light": "_spectrum--light_5be2e",
  "spectrum--lightest": "_spectrum--lightest_5be2e"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-large.css
var $a43560ac21eb0f39f37bdbcf14c4bbb1$exports = {};
$a43560ac21eb0f39f37bdbcf14c4bbb1$exports = {
  "spectrum--large": "_spectrum--large_4f200"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-light.css
var $b8b29f8db71e5640156222f235cf7db$exports = {};
$b8b29f8db71e5640156222f235cf7db$exports = {
  "spectrum--light": "_spectrum--light_606b7"
};
// ASSET: /Users/govett/dev/react-spectrum-v3/node_modules/@adobe/spectrum-css-temp/vars/spectrum-medium.css
var $dc84ce727b320e037f29b6ab6c663$exports = {};
$dc84ce727b320e037f29b6ab6c663$exports = {
  "spectrum--medium": "_spectrum--medium_b3c97"
};
var $feb906e4032856f299caea9c$$interop$default = $parcel$interopDefault($feb906e4032856f299caea9c$exports);
var $b8b29f8db71e5640156222f235cf7db$$interop$default = $parcel$interopDefault($b8b29f8db71e5640156222f235cf7db$exports);
var $e5b9ee4a968dfaea64b1b8cf98dc184$$interop$default = $parcel$interopDefault($e5b9ee4a968dfaea64b1b8cf98dc184$exports);
var $dc84ce727b320e037f29b6ab6c663$$interop$default = $parcel$interopDefault($dc84ce727b320e037f29b6ab6c663$exports);
var $a43560ac21eb0f39f37bdbcf14c4bbb1$$interop$default = $parcel$interopDefault($a43560ac21eb0f39f37bdbcf14c4bbb1$exports);
export let theme = {
  global: $feb906e4032856f299caea9c$$interop$default,
  light: $b8b29f8db71e5640156222f235cf7db$$interop$default,
  dark: $e5b9ee4a968dfaea64b1b8cf98dc184$$interop$default,
  medium: $dc84ce727b320e037f29b6ab6c663$$interop$default,
  large: $a43560ac21eb0f39f37bdbcf14c4bbb1$$interop$default
};
//# sourceMappingURL=module.js.map
